import Game from "../common/game";
import SportCodes from "../common/sport-codes";

export default class TennisGame extends Game {
    constructor(event, sportCode) {
        super(event);
        this.sportCode = sportCode || SportCodes.Tennis;
    }
}
